import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';
import { Place } from '@mui/icons-material';
import CustomTooltip from '../../atoms/CustomTooltip';
import { useGeneralContext } from '../../../../context/GeneralContext';

const AddressIconButton = ({ address, placement }) => {
  const { t } = useTranslation();
  const { openToast } = useGeneralContext();
  const onCopy = () => {
    navigator.clipboard.writeText(address);
    openToast(t('machines.facilities.center_pane.address_copied'));
  };

  return (
    <CustomTooltip title={address} placement={placement}>
      <IconButton color="inherit" size="small" onClick={onCopy}>
        <Place />
      </IconButton>
    </CustomTooltip>
  );
};

AddressIconButton.propTypes = {
  address: PropTypes.string.isRequired,
  placement: PropTypes.string,
};

export default AddressIconButton;
